import React from 'react'

import { NavLink } from 'react-router-dom'

import { List, ListItem, ListItemText, useTheme } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const NavItems = (props) => {
	const { selectedFacility } = props
	const classes = useStyles()
	return (
		<List className={classes.defaultNav}>
		
			<ListItem
				component={NavLink}
				exact
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/groomingHome`}>
				<ListItemText primary="Grooming Schedule" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/groomingCalendar`}>
				<ListItemText primary="Grooming Calendar" />
			</ListItem>
			<ListItem
				component={NavLink}
				className={classes.listItem}
				to={`/clients`}>
				<ListItemText primary="Clients" />
			</ListItem>
			
		</List>
	)
}

export default NavItems
